import get from 'lodash/get';
import { parse } from 'qs';
import { canUseDOM } from 'exenv';
import * as htmlSitemapPostActions from '../../action_creators/html_sitemap/html_sitemap_post_action_creators';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import HtmlSitemapPost from '../../../models/html_sitemap/html_sitemap_post';
import log from '../../../services/logger_service';

export default function fetchSearchAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(htmlSitemapPostActions.htmlSitemapPostLoading({}, store));

    const state = store.getState();

    let startDate = get(state, 'config.initialQueryParams.startDate');
    let endDate = get(state, 'config.initialQueryParams.endDate');

    if (canUseDOM) {
      const queryParams = parse(window.location.search.replace('?', ''));
      startDate = get(queryParams, 'startDate');
      endDate = get(queryParams, 'endDate');
    }

    return HtmlSitemapPost.fetch({ startDate, endDate }, store)
      .then(function handleSiteMapPostModelData(htmlSitemapPostData) {
        const htmlSitemapPostDataCloneData = htmlSitemapPostData.data;
        if (htmlSitemapPostDataCloneData) {
          htmlSitemapPostDataCloneData.startDate = startDate;
          htmlSitemapPostDataCloneData.endDate = endDate;
        }
        dispatch(
          htmlSitemapPostActions.htmlSitemapPostLoaded(
            htmlSitemapPostDataCloneData,
            store
          )
        );
      })
      .catch(function handleSiteMapPostError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }
        dispatch(htmlSitemapPostActions.htmlSitemapPostError(err.data, store));
        log.error(
          err,
          `Error in htmlSitemapPost actions, message: ${err.message}`
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/html_sitemap/async_html_sitemap_post_actions.js